import Message from './index.vue'

export default {
	install (Vue, options = {}) {
		
		let message = null;
		
		const VueMessage = Vue.extend(Message);

		function $message(text = '', type = 'top') {
			
			if (!message) {
				
				message = new VueMessage();

				message.$mount();
				
				document.querySelector(options.container || 'body').appendChild(message.$el);
			}

			return message.show(text, type);
		}

		Vue.prototype.$message = $message;
	}
}